const moment = require("moment");

var bd_macizo = "SBO_MACIZO";
var bd_SI = "SBO_SANTAINES";
var bd_TR = "SBO_TRANSFLESA";

// let sociedades = [
//   { id: 1, name: "MACIZO", bd: bd_macizo },
//   { id: 2, name: "SANTA INES", bd: bd_SI },
//   { id: 3, name: "TRANSFLESA", bd: bd_TR },
// ];

let tempPlantasUnion = [
  { name: "CKC-K1", Code: "CKC-K1" },
  { name: "CKC-K2", Code: "CKC-K2" },
  { name: "CKC-K3", Code: "CKC-K3" },
  { name: "CKC-K4", Code: "CKC-K4" },
  { name: "CKC-K5", Code: "CKC-K5" },
  { name: "PAE", Code: "PAE" },
  { name: "PAX", Code: "PAX" },
  { name: "PVC", Code: "PVC" },
  { name: "PVE", Code: "PVE" },
  { name: "PVE2", Code: "PVE2" },
  { name: "PVG", Code: "PVG" },
  { name: "PVR/PVR2", Code: "PVR" },
  { name: "PVX", Code: "PVX" },
  { name: "PVH", Code: "PVH" },
  { name: "TEJAS", Code: "TEJAS" },
  { name: "TEJAS 2", Code: "TEJAS 2" },
];

let tempPlantas = [
  // { Code: "CDA" },
  { Code: "CKC-K1" },
  { Code: "CKC-K2" },
  { Code: "CKC-K3" },
  { Code: "CKC-K4" },
  { Code: "CKC-K5" },
  { Code: "PAE" },
  { Code: "PAR" },
  { Code: "PAX" },
  { Code: "PVC" },
  { Code: "PVE" },
  { Code: "PVE2" },
  { Code: "PVG" },
  { Code: "PVR" },
  { Code: "PVR2" },
  { Code: "PVX" },
  { Code: "PVH" },
  { Code: "TEJAS" },
  { Code: "TEJAS 2" },
];
let tempPlantasVibro = [
  // { Code: "CDA" },
  { Code: "CKC-K1" },
  { Code: "CKC-K2" },
  { Code: "CKC-K3" },
  { Code: "CKC-K4" },
  { Code: "CKC-K5" },
  // { Code: "PAE" },
  // { Code: "PAR" },
  // { Code: "PAX" },
  { Code: "PVC" },
  { Code: "PVE" },
  { Code: "PVE2" },
  { Code: "PVG" },
  { Code: "PVR" },
  { Code: "PVR2" },
  { Code: "PVX" },
  { Code: "PVH" },
  { Code: "TEJAS" },
  { Code: "TEJAS 2" },
];
let series = [
  { dataField: "LozaPrefabricada", displayText: "Loza Prefabricada" },
  { dataField: "BlockAltaResistencia", displayText: "Block AR" },
  { dataField: "BlockNoEstructural", displayText: "Block Tipo NC" },
  { dataField: "AdoquinDecorativo", displayText: "Adoquin Decorativo" },
  { dataField: "AdoquinTipoCruz", displayText: "Adoquin Tipo Cruz" },
  { dataField: "MuroPerimetral", displayText: "Muro Perimetral" },
  { dataField: "Rustiblock", displayText: "RUSTIBLOCK" },
  { dataField: "Tuberia", displayText: "Tuberia" },
  { dataField: "Bordillo", displayText: "Bordillo" },
  { dataField: "CajasParaContador", displayText: "Cajas Para Contador" },
  { dataField: "Letrinas", displayText: "LETRINAS" },
  { dataField: "Pilas", displayText: "PILAS" },
  { dataField: "ReposaderaDeConcreto", displayText: "REPOSADERA DE CONCRETO" },
  { dataField: "TapaderasDeConcreto", displayText: "TAPADERAS DE CONCRETO" },
  { dataField: "Tejas", displayText: "Tejas" },
  { dataField: "Fachaletas", displayText: "Fachaletas" },
  { dataField: "PostesDeConcreto", displayText: "Postes De Concreto" },
  { dataField: "TopesDeParqueo", displayText: "Topes De Parqueo" },
  { dataField: "ArenaDeRio", displayText: "Arena De Rio" },
  { dataField: "PiedrinUnMedio", displayText: "Piedrin 1/2" },
  { dataField: "PiedrinTresOctavos", displayText: "Piedrin 3/8" },
  { dataField: "PolvoDePiedra", displayText: "Polvo De Piedra" },
  { dataField: "SinGrupo", displayText: "Sin Grupo" },
];
const seriesGroups = [
  {
    columnsGapPercent: 50,
    series: series,
    seriesGapPercent: 5,
    type: "stackedcolumn",
  },
];

//----------------------------------
const xAxisInterno = {
  // visible: 0,
  labels: { angle: 90 },
  padding: { top: 0, bottom: 0 },
  dataField: "Planta",
  displayText: 'Producto',
  gridLines: {
    color: "#888888",
    interval: 1,
    visible: false,
  },
  tickMarks: {
    color: "#888888",
    interval: 1,
    visible: true,
  },
  unitInterval: 1,
};
//----------------------------------

const xAxis = {
  dataField: "Name",
  gridLines: {
    color: "#888888",
    interval: 1,
    visible: false,
  },
  tickMarks: {
    color: "#888888",
    interval: 1,
    visible: true,
  },
  unitInterval: 1,
};
const xAxisMes = {
  dataField: "Mes",
  gridLines: {
    color: "#888888",
    interval: 1,
    visible: false,    
  },
  padding: { top: 0, bottom: 0 },
                // tickMarks: { color: '#CDCDCD' },
                valuesOnTicks: false,
  
  tickMarks: {
    color: "#888888",
    interval: 1,
    visible: true,
  },
  unitInterval: 1,
};
const xAxisPeriodo = {
  dataField: "Periodo",
  gridLines: {
    color: "#888888",
    interval: 1,
    visible: false,
  },
  tickMarks: {
    color: "#888888",
    interval: 1,
    visible: true,
  },
  unitInterval: 10,
};
const valueAxis = {
  gridLines: { color: "#888888" },
  tickMarks: { color: "#888888" },
  visible: true,
  minValue: 0,
};
const labels = {
  offset: { x: 0, y: 0 },
  autoRotate: true,
  visible: true,
  //class: "CSS",
  backgroundColor: "white",
  backgroundOpacity: 0.7,
  borderColor: "#89A54E",
  //borderOpacity: 0.7,
  class: "#89A54E",
  padding: { left: 5, right: 5, top: 1, bottom: 1 },
  //visible: true,
};
const labels_not_color = {
  offset: { x: 0, y: 0 },
  autoRotate: true,
  visible: true,
  class: "CSS",
};

const titlePadding = { left: 90, top: 0, right: 0, bottom: 10 };
const padding = { left: 5, top: 5, right: 5, bottom: 5 };
var responsiveBar = [
  [
    "screen and (max-width: 640px)",
    {
      seriesBarDistance: 5,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value[0];
        },
      },
    },
  ],
];

const options_Months = [
  { name: "enero", id: "1" },
  { name: "Febrero", id: "2" },
  { name: "Marzo", id: "3" },
  { name: "Abril", id: "4" },
  { name: "Mayo", id: "5" },
  { name: "Junio", id: "6" },
  { name: "Julio", id: "7" },
  { name: "Agosto", id: "8" },
  { name: "Septiembre", id: "9" },
  { name: "Octubre", id: "10" },
  { name: "Noviembre", id: "11" },
  { name: "Diciembre", id: "12" },
];



let data_year = [];
let today = moment().format("YYYY");
let fiveYear = today - 4;

var i;
for (i = fiveYear; i <= today; i++) {
  data_year.push({ i });
}
var data_new_plantas = [];
var code_planta = [
  "All",
  "P08",
  "P09",
  "P02",
  "P03",
  "P14",
  "P19",
  "P05",
  "P06",
  "P16",
  "P01",
  "PAE",
  "CDA",
  "P07",
  "P11",
  "P18",
  "P20",
  "P21",
];
var name_planta = [
  "All",
  "CKC-K1",
  "CKC-K2",
  "CKC-K3",
  "CKC-K4",
  "CKC-K5",
  "TEJAS",
  "PVC",
  "PVX",
  "PVR",
  "PVE",
  "PAE",
  "CDA",
  "PAX",
  "PAR",
  "PVE2",
  "PVG",
  "PVR2",
];


var K = 0;

for (var x = 0; x < code_planta.length; x++) {
  var row = {};
  row["code"] = code_planta[K];
  row["name"] = name_planta[K];
  data_new_plantas[x] = row;
  K++;






}

//-------------------

var data_new_plantasV = [];
var code_plantaV = [
  "All",
  "CKC-K1",
  "CKC-K2",
  "CKC-K3",
  "CKC-K4",
  "CKC-K5",
  "TEJAS",
  "TEJAS 2",
  "PVC",
  "PVX",
  "PVR",
  "PVE",
  "PAE",
  "CDA",
  "PAX",
  "PAR",
  "PVE2",
  "PVG",
  "PVH",
  "PVR2",
];
var name_plantaV = [
  "All",
  "CKC-K1",
  "CKC-K2",
  "CKC-K3",
  "CKC-K4",
  "CKC-K5",
  "TEJAS",
  "TEJAS 2",
  "PVC",
  "PVX",
  "PVR",
  "PVE",
  "PAE",
  "CDA",
  "PAX",
  "PAR",
  "PVE2",
  "PVG",
  "PVH",
  "PVR2",
];


var KP = 0;

for (var xp = 0; xp < code_plantaV.length; xp++) {
  var rowp = {};
  rowp["code"] = code_plantaV[KP];
  rowp["name"] = name_plantaV[KP];
  data_new_plantasV[xp] = rowp;
  KP++;

}

//----------------------



var data_plantas_inventario_comercial = [];
var code_ventas_comercial = [
  "P08",
  "P09",
  "P02",
  "P03",
  "P14",
  "P05",
  "P06",
  "P16",
  "P01",
  "P18",
  "P20",
  "P21",
  "P22",
];
var name_ventas_comercial = [
  "CKC-K1",
  "CKC-K2",
  "CKC-K3",
  "CKC-K4",
  "CKC-K5",
  "PVC",
  "PVX",
  "PVR",
  "PVE",
  "PVE2",
  "PVG",
  "PVR2",
  "PVH",
];

var R = 0;


for (var b = 0; b < code_ventas_comercial.length; b++) {
  var row_comercial = {};
  row_comercial["code_ventas_comercial"] = code_ventas_comercial[R];
  row_comercial["name_ventas_comercial"] = name_ventas_comercial[R];
  data_plantas_inventario_comercial[b] = row_comercial;
  R++;
}

var data_consumo_materia_prima = [];
var code_materia_prima = [
  "All",
  "P08",
  "P09",
  "P02",
  "P03",
  "P14",
  "P05",
  "P01",
  "P06",
  "P16",
  "P18",
  "P19",
  "P21",
  "P22",
];
var name_materia_prima = [
  "All",
  "CKC-K1",
  "CKC-K2",
  "CKC-K3",
  "CKC-K4",
  "CKC-K5",
  "PVC",
  "PVE",
  "PVX",
  "PVR",
  "PVE2",
  "PVG",
  "PVR2",
  "PVH",
];

var MP = 0;

for (var mp = 0; mp < code_materia_prima.length; mp++) {
  var materia_prima = {};
  materia_prima["code_materia_prima"] = code_materia_prima[MP];
  materia_prima["name_materia_prima"] = name_materia_prima[MP];
  data_consumo_materia_prima[mp] = materia_prima;
  MP++;
}

var data_plan_produccion = [];
var code_plan_prod = [
  "All",
  "P08",
  "P09",
  "P02",
  "P03",
  "P14",
  "P05",
  "P01",
  "P18",
  "P06",
  "P16",
  "P20",
  "P21",
  "P22",
];
var name_plan_prod = [
  "All",
  "CKC-K1",
  "CKC-K2",
  "CKC-K3",
  "CKC-K4",
  "CKC-K5",
  "PVC",
  "PVE",
  "PVE2",
  "PVX",
  "PVR",
  "PVG",
  "PVR2",
  "PVH",
];

var PP = 0;

for (var pp = 0; pp < code_plan_prod.length; pp++) {
  var plan_produccion = {};
  plan_produccion["code_plan_prod"] = code_plan_prod[PP];
  plan_produccion["name_plan_prod"] = name_plan_prod[PP];
  data_plan_produccion[pp] = plan_produccion;
  PP++;
}

var data_despacho_por_planta = [];
var code_des_planta = [
  "All",
  "C113",
  "C213",
  "C313",
  "C413",
  "C513",
  "B113",
  "D113",
  "K113",
  "E113",
  "D213",
  "L113",
  "K213",
];
var name_des_planta = [
  "Seleccione Una Planta",
  "CKC-K1",
  "CKC-K2",
  "CKC-K3",
  "CKC-K4",
  "CKC-K5",
  "PVC",
  "PVE",
  "PVR",
  "PVX",
  "PVE2",
  "PVG",
  "PVR2",
];

var DP = 0;

for (var dp = 0; dp < code_des_planta.length; dp++) {
  var despachoPorPlanta = {};
  despachoPorPlanta["code_des_planta"] = code_des_planta[DP];
  despachoPorPlanta["name_des_planta"] = name_des_planta[DP];
  data_despacho_por_planta[dp] = despachoPorPlanta;
  DP++;
}

const data_columns_same = [
  {
    text: "1",
    datafield: "D1",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "2",
    datafield: "D2",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "3",
    datafield: "D3",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "4",
    datafield: "D4",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "5",
    datafield: "D5",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "6",
    datafield: "D6",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "7",
    datafield: "D7",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "8",
    datafield: "D8",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "9",
    datafield: "D9",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "10",
    datafield: "D10",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "11",
    datafield: "D11",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "12",
    datafield: "D12",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "13",
    datafield: "D13",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "14",
    datafield: "D14",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "15",
    datafield: "D15",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "16",
    datafield: "D16",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "17",
    datafield: "D17",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "18",
    datafield: "D18",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "19",
    datafield: "D19",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "20",
    datafield: "D20",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "21",
    datafield: "D21",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "22",
    datafield: "D22",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "23",
    datafield: "D23",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "24",
    datafield: "D24",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "25",
    datafield: "D25",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "26",
    datafield: "D26",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "27",
    datafield: "D27",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "28",
    datafield: "D28",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "29",
    datafield: "D29",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "30",
    datafield: "D30",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
  {
    text: "31",
    datafield: "D31",
    width: 75,
    align: "rigth",
    cellsalign: "center",
    columntype: "numberinput",
    cellsformat: "N",
  },
];
// var bd_macizo = "SBO_MACIZO";
// var bd_SI = "SBO_SANTAINES";
// var bd_TR = "SBO_TRANSFLESA";

let sociedades = [
  { id: 1, name: "MACIZO", bd: bd_macizo },
  { id: 2, name: "SANTA INES", bd: bd_SI },
  { id: 3, name: "TRANSFLESA", bd: bd_TR },
];
let UrlAutorizaciones = [
  {
    id: 1,
    name: "MACIZO",
    bd: bd_macizo,
    url: "http://190.56.9.222:8082/Autoriza/AutorizaMacizo",
  },
  {
    id: 2,
    name: "AGREGADOS",
    bd: bd_SI,
    url: "http://190.56.9.222:8082/Autoriza/AutorizaSantaInes",
  },
  {
    id: 3,
    name: "TRANSFLESA",
    bd: bd_TR,
    url: "http://190.56.9.222:8082/Autoriza/AutorizaTransflesa",
  },
];
module.exports = {
  sociedades,
  UrlAutorizaciones,
  tempPlantas,
  tempPlantasUnion,
  tempPlantasVibro,
  series,
  seriesGroups,
  xAxisInterno,
  xAxis,
  titlePadding,
  padding,
  responsiveBar,
  options_Months,
  data_year,
  xAxisMes,
  valueAxis,
  labels,
  labels_not_color,
  xAxisPeriodo,
  data_new_plantas,
  data_new_plantasV,
  data_plantas_inventario_comercial,
  data_consumo_materia_prima,
  data_plan_produccion,
  data_columns_same,
  data_despacho_por_planta,
};
